import { BoxStaffCoachIcon } from "@images/svgIcons/boxStaff/boxStaffCoachIcon"
import { BoxStaffCoOwnerIcon } from "@images/svgIcons/boxStaff/boxStaffCoOwnerIcon"
import { BoxStaffFinancialIcon } from "@images/svgIcons/boxStaff/boxStaffFinancialIcon"
import { BoxStaffHeadCoachIcon } from "@images/svgIcons/boxStaff/boxStaffHeadCoachIcon"
import { BoxStaffOwnerIcon } from "@images/svgIcons/boxStaff/boxStaffOwnerIcon"
import { BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"
import { word } from "@modules/core/utils/i18n"
import { Skeleton } from "primereact/skeleton"

export function displayIcon(color: string, size: number, role?: BoxStaffRole): React.JSX.Element {
  const icons = {
    OWNER: <BoxStaffOwnerIcon color={color} size={size} />,
    CO_OWNER: <BoxStaffCoOwnerIcon color={color} size={size} />,
    HEAD_COACH: <BoxStaffHeadCoachIcon color={color} size={size} />,
    COACH: <BoxStaffCoachIcon color={color} size={size} />,
    FINANCIAL: <BoxStaffFinancialIcon color={color} size={size} />,
  }
  if (!role) return <Skeleton shape="circle" size={`${size}px`} />
  return icons[role]
}

export function displayRole(role: BoxStaffRole): string {
  const roles = {
    OWNER: word("staff.role.owner"),
    CO_OWNER: word("staff.role.co_owner"),
    HEAD_COACH: word("staff.role.head_coach"),
    COACH: word("staff.role.coach"),
    FINANCIAL: word("staff.role.financial"),
  }
  return roles[role]
}
